/* ============================================================
   Atrium Legal カスタムJS（Shopify テーマ用）
   - スクロール reveal アニメーション（.reveal → .is-visible）
   - モバイルメニュー開閉 / ヘッダー影（静的HTML互換。Shopify版ヘッダーは
     Dawn ドロワーが担当するため、対象要素が無ければ no-op）
   - shopify/assets/ 直下フラット配置（Shopify はサブフォルダ不可）
   - 読み込み: layout/theme.liquid 内 {{ 'add-script.js' | asset_url }}（defer）
   ============================================================ */
(function () {
  'use strict';

  // スクロール reveal アニメーション（.reveal に .is-visible を付与）
  var revealTargets = document.querySelectorAll('.reveal');
  if (revealTargets.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      revealTargets.forEach(function (el) { revealObserver.observe(el); });
    } else {
      // 非対応ブラウザは即表示（非表示のまま残さない）
      revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // モバイルメニュー開閉
  var burgerBtn = document.getElementById('burger-btn');
  var mobileMenu = document.getElementById('mobile-menu');

  if (burgerBtn && mobileMenu) {
    burgerBtn.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      burgerBtn.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    mobileMenu.querySelectorAll('[data-close-menu]').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        burgerBtn.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  // スクロールで影を追加
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(11, 31, 58, .25)'
        : '';
    }, { passive: true });
  }
})();
